// extracted by mini-css-extract-plugin
export default {"loginBg":"login_loginBg__ZuMmp"};